module.exports = __webpack_public_path__ + "static/img/送气.e746cf36.png";